import React, { useState } from "react";
import Loadspinner from "../../../common/Loadspinner";
import "react-toastify/dist/ReactToastify.css";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import {
  insertUpdateFolders
} from "../../../helpers/API/APIEndPoints";
import moment from "moment";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { APICall } from "../../../helpers/API/APICalls";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import {
  saveRecordMsg,
  updateRecordMsg,
} from "../../../helpers/Constants/Constants";
import Main from "../../../common/Main/Main";
import { useHistory } from "react-router-dom";
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";

const BulkUploadDocumentEdit = () => {
  let history = useHistory();
  const [formErrors, setFormErrors] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [editModeDisableButton, setEditModeDisableButton] = useState(true);
  const [folderName, setFolderName] = useState('');

  let formErrorObj = {};


  const handleTextEvent = async (event, field) => {
    var error = undefined;
    let tempName = event.target.value;
    var setError = "";

    if (field === "name") {
      setFolderName(tempName);
      setError = "Folder Name";
    }

    if (tempName == undefined || tempName == null || tempName.trim() == "") {
      error = setError + " Cannot Be Empty";
    }

    setFormErrors((preState) => ({
      ...preState,
      [setError.replaceAll(" ", "") + "_isEmpty"]: error,
    }));
  };

  const onClickFunction = async (event, action) => {
    if (action === "Submit") {
      await checkValidations();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x === undefined
      );

      if (isEmpty) {
        setLoading(true);
        let Id = 0;
        let requestParams = {
          Id: Id,
          FolderName: folderName.replace(/\s+/g, " ").trim(),
          Status: 0,
          IsActive: isActive,
          CreatedDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          UserId: getFromEncLocalStorage("userId"), //UserId
        };

        const res = await APICall(insertUpdateFolders, requestParams, "POST");
        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            if (Id === 0) {
              notify(0, saveRecordMsg);
            } else if (Id > 0) {
              notify(0, updateRecordMsg);
            }
            history.push({ pathname: "/bulk-upload-document" });
          }
          setLoading(false);
        } else {
          notify(1, res.message);
          setLoading(false);
        }
        setLoading(false);
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/bulk-upload-document" });
    }
  };

  const resetFunction = () => {
    setFolderName("");
    setFormErrors({});
    formErrorObj = {};
  };

  const checkValidations = async () => {
    var objError = {};
    var setError = "";
    if (
      folderName == undefined ||
      folderName == null ||
      folderName.trim() == ""
    ) {
      setError = "Folder Name";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        "Folder Name Cannot Be Empty";
    } else if (folderName.replace(/\s+/g, " ").trim().length >= 20) {
      setError = "Folder Name";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        "Folder Name Is Longer Than The 20 Character";
    }

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  return (
    <>
      <Main active={"bulk_upload_document"} removeContainer={true}>
        <Loadspinner filename="BulkUploadDocumentEdit.js" isLoading={isLoading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-6">
                <h4 style={{ paddingLeft: "5px" }}>
                  Knowledge Creation Bulk Upload
                </h4>
              </div>
              <hr></hr>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-xs-3 ">
                    <div className="form-group">
                      <FormLabel value="Folder Name"></FormLabel>
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Folder Name"}
                        isDisabled={editMode ? true : false}
                        textArea={false}
                        value={folderName}
                        onChange={(e) => handleTextEvent(e, "name")}
                      />
                      <ErrorLabel value={formErrors["FolderName_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-xs-3 ">
                    <div className="form-group">
                      <FormLabel value="Active Status"></FormLabel>
                      <div className="custom-checkbox">
                        <input
                          disabled={editMode ? false : true}
                          type="checkbox"
                          onChange={(e) => setIsActive(e.target.checked)}
                          name="isActive"
                          checked={isActive}
                          className="isActive"
                          autoComplete={CommonConstants.autoCompleteInput}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                    <div className="float-right">
                      <SubmitButton
                        onClick={(e) => onClickFunction(e, "Submit")}
                      />
                      {editModeDisableButton && (
                        <ResetButton
                          onClick={(e) => onClickFunction(e, "Reset")}
                        />
                      )}
                      <CancelButton
                        onClick={(e) => onClickFunction(e, "Cancel")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  );
};

export default BulkUploadDocumentEdit;
